(function () {
  if (window.__customShippingProgressLoaded) return;
  window.__customShippingProgressLoaded = true;

  const CFGS = {
    IT: {
      thresholds: [30],
      badges: ['FREE'],
      shippingCosts: [14.5, 0]
    },
    EU_STD: {
      thresholds: [50],
      badges: ['FREE'],
      shippingCosts: [20.0, 0]
    },
    EU_FRIGO: {
      thresholds: [40, 60, 80, 100],
      badges: ['-25%', '-45%', '-65%', 'FREE'],
      shippingCosts: [41.1, 30.8, 22.6, 14.4, 0]
    }
  };

  const FREE_BADGE = {
    EN: 'FREE',
    IT: 'GRATIS',
    DE: 'KOSTENLOS',
    FR: 'GRATUIT',
    ES: 'GRATIS'
  };

  const TITLES = {
    IT: 'Spedizione espressa',
    EN: 'Express shipping',
    DE: 'Expressversand',
    FR: 'Livraison express',
    ES: 'Envío exprés'
  };

  const STRINGS = {
  IT: {
    payNow: (x) => `Spedizione attuale: ${x}.`,
    next25: (a) => `Aggiungi <span class="spb__accent">${a}</span> per ottenere il <strong>-25%</strong> sulla spedizione.`,
    next45: (a) => `Aggiungi <span class="spb__accent">${a}</span> per ottenere il <strong>-45%</strong> sulla spedizione.`,
    next65: (a) => `Aggiungi <span class="spb__accent">${a}</span> per ottenere il <strong>-65%</strong> sulla spedizione.`,
    next65Urgent: (a) => `Ti mancano solo <span class="spb__accent">${a}</span> per ottenere il <strong>-65%</strong> sulla spedizione.`,
    nextFree: (a) => `Aggiungi <span class="spb__accent">${a}</span> per ottenere la <strong>spedizione gratuita</strong>.`,
    nextFreeUrgent: (a) => `Ti mancano solo <span class="spb__accent">${a}</span> per ottenere la <strong>spedizione gratuita</strong>.`,
    unlocked: `Hai sbloccato la <strong>spedizione gratuita</strong>.`,
    nextStep: (thr, cost) => `Con un carrello da ${thr} la spedizione scende a ${cost}.`
  },
  EN: {
    payNow: (x) => `Current shipping: ${x}.`,
    next25: (a) => `Add <span class="spb__accent">${a}</span> to get <strong>-25%</strong> shipping.`,
    next45: (a) => `Add <span class="spb__accent">${a}</span> to get <strong>-45%</strong> shipping.`,
    next65: (a) => `Add <span class="spb__accent">${a}</span> to get <strong>-65%</strong> shipping.`,
    next65Urgent: (a) => `Only <span class="spb__accent">${a}</span> left to unlock <strong>-65%</strong> shipping.`,
    nextFree: (a) => `Add <span class="spb__accent">${a}</span> to get <strong>free shipping</strong>.`,
    nextFreeUrgent: (a) => `Only <span class="spb__accent">${a}</span> left to unlock <strong>free shipping</strong>.`,
    unlocked: `You unlocked <strong>free shipping</strong>.`,
    nextStep: (thr, cost) => `At ${thr}, shipping drops to ${cost}.`
  },
  DE: {
    payNow: (x) => `Aktuelle Versandkosten: ${x}.`,
    next25: (a) => `Füge <span class="spb__accent">${a}</span> hinzu und erhalte <strong>-25%</strong> Versand.`,
    next45: (a) => `Füge <span class="spb__accent">${a}</span> hinzu und erhalte <strong>-45%</strong> Versand.`,
    next65: (a) => `Füge <span class="spb__accent">${a}</span> hinzu und erhalte <strong>-65%</strong> Versand.`,
    next65Urgent: (a) => `Nur noch <span class="spb__accent">${a}</span> bis zu <strong>-65%</strong> Versand.`,
    nextFree: (a) => `Füge <span class="spb__accent">${a}</span> hinzu und erhalte <strong>kostenlosen Versand</strong>.`,
    nextFreeUrgent: (a) => `Nur noch <span class="spb__accent">${a}</span> bis zum <strong>kostenlosen Versand</strong>.`,
    unlocked: `<strong>Kostenloser Versand</strong> freigeschaltet.`,
    nextStep: (thr, cost) => `Ab ${thr} sinken die Versandkosten auf ${cost}.`
  },
  FR: {
    payNow: (x) => `Livraison actuelle : ${x}.`,
    next25: (a) => `Ajoutez <span class="spb__accent">${a}</span> pour obtenir <strong>-25%</strong> sur la livraison.`,
    next45: (a) => `Ajoutez <span class="spb__accent">${a}</span> pour obtenir <strong>-45%</strong> sur la livraison.`,
    next65: (a) => `Ajoutez <span class="spb__accent">${a}</span> pour obtenir <strong>-65%</strong> sur la livraison.`,
    next65Urgent: (a) => `Plus que <span class="spb__accent">${a}</span> pour obtenir <strong>-65%</strong> sur la livraison.`,
    nextFree: (a) => `Ajoutez <span class="spb__accent">${a}</span> pour obtenir la <strong>livraison gratuite</strong>.`,
    nextFreeUrgent: (a) => `Plus que <span class="spb__accent">${a}</span> pour obtenir la <strong>livraison gratuite</strong>.`,
    unlocked: `Vous avez débloqué la <strong>livraison gratuite</strong>.`,
    nextStep: (thr, cost) => `À partir de ${thr}, la livraison descend à ${cost}.`
  },
  ES: {
    payNow: (x) => `Envío actual: ${x}.`,
    next25: (a) => `Añade <span class="spb__accent">${a}</span> para conseguir <strong>-25%</strong> en el envío.`,
    next45: (a) => `Añade <span class="spb__accent">${a}</span> para conseguir <strong>-45%</strong> en el envío.`,
    next65: (a) => `Añade <span class="spb__accent">${a}</span> para conseguir <strong>-65%</strong> en el envío.`,
    next65Urgent: (a) => `Solo faltan <span class="spb__accent">${a}</span> para conseguir <strong>-65%</strong> en el envío.`,
    nextFree: (a) => `Añade <span class="spb__accent">${a}</span> para conseguir <strong>envío gratis</strong>.`,
    nextFreeUrgent: (a) => `Solo faltan <span class="spb__accent">${a}</span> para conseguir <strong>envío gratis</strong>.`,
    unlocked: `Has desbloqueado el <strong>envío gratis</strong>.`,
    nextStep: (thr, cost) => `Con un carrito de ${thr}, el envío baja a ${cost}.`
  }
};

  function getWraps() {
    return Array.from(document.querySelectorAll('.spb[id^="shipping-progress-"]'));
  }

  function money(n, moneyFormat) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFormat) {
        return Shopify.formatMoney(Math.round(n * 100), moneyFormat);
      }
    } catch (e) {}

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'EUR'
      }).format(n);
    } catch (e) {
      return `${n.toFixed(2)} €`;
    }
  }

  function tierBySubtotal(subtotal, thresholds) {
    let tier = 0;
    for (let i = 0; i < thresholds.length; i++) {
      if (subtotal >= thresholds[i]) tier = i + 1;
    }
    return tier;
  }

  function getMode(cart, market, refrigeratedHandles) {
    if (market === 'IT') return 'IT';

    const hasRefrig = Array.isArray(cart.items) && cart.items.some((item) => refrigeratedHandles.has(item.handle));
    return hasRefrig ? 'EU_FRIGO' : 'EU_STD';
  }

  function setMilestonesPositions(wrap, cfg, locale) {
    const nodes = Array.from(wrap.querySelectorAll('.spb__milestone'));
    const thresholds = cfg.thresholds.slice();
    const badges = cfg.badges.slice();
    const max = thresholds[thresholds.length - 1] || 100;

    nodes.forEach((node, index) => {
      const threshold = thresholds[index];

      if (typeof threshold === 'undefined') {
        node.style.display = 'none';
        return;
      }

      node.style.display = 'block';
      node.dataset.threshold = String(threshold);

      const label = node.querySelector('.spb__label');
      const badge = node.querySelector('.spb__badge');

      if (label) label.textContent = `${threshold}€`;

      let badgeText = badges[index] || '';
      if (badgeText === 'FREE') badgeText = FREE_BADGE[locale] || 'FREE';
      if (badge) badge.textContent = badgeText;

      node.style.left = `${(threshold / max) * 100}%`;
    });
  }

  function updateWrap(wrap, cart) {
    if (!wrap) return;

    const locale = (wrap.dataset.locale || 'EN').toUpperCase();
    const market = (wrap.dataset.market || 'EU').toUpperCase();
    const moneyFormat = wrap.dataset.moneyFormat || '';
    const refrigeratedHandles = new Set(
      (wrap.dataset.refrigeratedHandles || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    );

    const strings = STRINGS[locale] || STRINGS.EN;
    const mode = getMode(cart, market, refrigeratedHandles);
    const cfg = CFGS[mode];
    const subtotal = ((cart.items_subtotal_price ?? cart.total_price ?? 0) / 100);

    const titleEl = wrap.querySelector('.spb__title');
    const statusEl = wrap.querySelector('.spb__status');
    const fillEl = wrap.querySelector('.spb__fill');
    const knobEl = wrap.querySelector('.spb__knob');
    const currentCostEl = wrap.querySelector('.spb__current-cost');
    const hintEl = wrap.querySelector('.spb__hint');

    if (!titleEl || !statusEl || !fillEl || !knobEl || !currentCostEl || !hintEl) return;

    titleEl.textContent = TITLES[locale] || TITLES.EN;
    setMilestonesPositions(wrap, cfg, locale);

    const thresholds = cfg.thresholds;
    const max = thresholds[thresholds.length - 1] || 100;
    const pct = Math.max(0, Math.min(100, (subtotal / max) * 100));

    fillEl.style.width = `${pct}%`;
    knobEl.style.left = `${pct}%`;

    const tier = tierBySubtotal(subtotal, thresholds);
    const nowCost = cfg.shippingCosts[Math.min(tier, cfg.shippingCosts.length - 1)];

    currentCostEl.textContent = strings.payNow(money(nowCost, moneyFormat));

    Array.from(wrap.querySelectorAll('.spb__milestone')).forEach((node) => {
      if (node.style.display === 'none') return;
      const threshold = parseFloat(node.dataset.threshold || '0');
      node.classList.toggle('spb--reached', subtotal >= threshold);
    });

    if (tier === thresholds.length) {
  statusEl.innerHTML = strings.unlocked;
  hintEl.textContent = '';
  return;
}

    const nextThreshold = thresholds[tier];
    const leftAmount = Math.max(0, nextThreshold - subtotal);
    const nextAmountFormatted = money(leftAmount, moneyFormat);

   const urgentThreshold = 7.5;
const isUrgent = leftAmount <= urgentThreshold;

if (mode === 'EU_FRIGO') {
  if (nextThreshold === 40) {
    statusEl.innerHTML = strings.next25(nextAmountFormatted);
  } else if (nextThreshold === 60) {
    statusEl.innerHTML = strings.next45(nextAmountFormatted);
  } else if (nextThreshold === 80) {
    statusEl.innerHTML = isUrgent
      ? strings.next65Urgent(nextAmountFormatted)
      : strings.next65(nextAmountFormatted);
  } else {
    statusEl.innerHTML = isUrgent
      ? strings.nextFreeUrgent(nextAmountFormatted)
      : strings.nextFree(nextAmountFormatted);
  }
} else {
  statusEl.innerHTML = isUrgent
    ? strings.nextFreeUrgent(nextAmountFormatted)
    : strings.nextFree(nextAmountFormatted);
}

if (isUrgent) {
  wrap.classList.add('spb--urgent');
} else {
  wrap.classList.remove('spb--urgent');
}

    const nextCost = cfg.shippingCosts[Math.min(tier + 1, cfg.shippingCosts.length - 1)];
    hintEl.textContent = tier >= thresholds.length - 1
      ? ''
      : strings.nextStep(money(nextThreshold, moneyFormat), money(nextCost, moneyFormat));
  }

  function refreshAll(cart) {
    getWraps().forEach((wrap) => updateWrap(wrap, cart));
  }

  function fetchCartAndRefresh() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => response.json())
      .then((cart) => {
        refreshAll(cart);
        return cart;
      })
      .catch(() => {
        refreshAll({ items: [], total_price: 0, items_subtotal_price: 0 });
      });
  }

  function debounce(fn, delay) {
    let timer = null;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  const debouncedRefresh = debounce(fetchCartAndRefresh, 180);

  document.addEventListener('DOMContentLoaded', debouncedRefresh);
  document.addEventListener('shopify:section:load', debouncedRefresh);
  document.addEventListener('shopify:section:reorder', debouncedRefresh);
  document.addEventListener('shopify:section:select', debouncedRefresh);
  document.addEventListener('cart:updated', debouncedRefresh);
  window.addEventListener('pageshow', debouncedRefresh);

  if (!window.__customShippingProgressFetchHooked) {
    window.__customShippingProgressFetchHooked = true;
    const originalFetch = window.fetch;

    window.fetch = function () {
      return originalFetch.apply(this, arguments).then((response) => {
        try {
          const url = String(arguments[0] || '');
          if (
            url.indexOf('/cart') !== -1 ||
            url.indexOf('/add') !== -1 ||
            url.indexOf('/change') !== -1 ||
            url.indexOf('/update') !== -1
          ) {
            debouncedRefresh();
          }
        } catch (e) {}
        return response;
      });
    };
  }

  if (document.readyState !== 'loading') {
    debouncedRefresh();
  }
})();